import React from 'react';
import { Box, Typography } from '@mui/material';

const SelectionButton = ({ selected, icon: Icon, title, description, onSelect }) => {
  return (
    <Box
      component="button"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '250px',
        padding: '25px',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: selected ? 'primary.main' : '#A19F9F',
        borderRadius: '16px',
        cursor: 'pointer',
        backgroundColor: selected ? 'primary.light' : 'white',
        '&:hover': {
            borderColor: 'primary.main',
        }
      }}
      onClick={onSelect}
    >
      <Box sx={{ margin: '12px', color: selected ? 'primary.main' : 'inherit' }}>
        <Icon sx={{ fontSize: 40}} size="40"/>
      </Box>
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 'bold',
          textTransform: 'uppercase',
          color: selected ? 'primary.main' : 'inherit',
          marginBottom: '4px',
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: selected ? 'primary.main' : 'inherit',
        }}
      >{description}</Typography>
    </Box>
  );
};

export default SelectionButton;
